import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import ProfileSectionPage from '../../../components/ProfileSectionPage/ProfileSectionPage';
import ImageUploader from '../../../components/common/Form/ImageUploader';
import { useBrandContext } from '../../../contexts/BrandContext';
import { uploadBrandLogo } from '../../../api/brand';

import './styles/_brand-profile-logo.scss';
import BrandProfileActions from './BrandProfileActions';

const BrandLogoPage = () => {
  const { currentBrand, refreshCurrentBrand } = useBrandContext();
  const [logoImage, setLogoImage] = useState<Blob | string | null>(currentBrand?.logoUrl || null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLogoImage(currentBrand?.logoUrl || null);
  }, [currentBrand?.id, currentBrand?.logoUrl]);

  const handleSave = async () => {
    if (!currentBrand || isSaving) return;

    if (!logoImage) {
      toast.error('Please select a brand logo before saving.');
      return;
    }

    if (typeof logoImage === 'string') {
      toast.info('There are no new logo changes to upload.');
      return;
    }

    setIsSaving(true);

    try {
      const formData = new FormData();
      formData.append('logo', logoImage, 'brand-logo');

      await uploadBrandLogo(currentBrand.id, formData);
      await refreshCurrentBrand();

      toast.success('Brand logo saved successfully.');
    } catch (error) {
      console.error('Failed to save brand logo:', error);
      toast.error('Failed to save brand logo.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ProfileSectionPage title="LOGO">
      <div className="brand-profile-logo-page">
        <div className="brand-profile-logo-section">
          <h2 className="brand-profile-logo-heading">BRAND LOGO</h2>

          <p className="brand-profile-logo-description">
            Upload your brand&apos;s logo to be used across all locations.{' '}
            <i>Please note that higher resolution files are more likely to display more clearly.</i>
          </p>

          <ImageUploader id="brand-logo" image={logoImage || ''} onUpdate={(file: Blob | null) => setLogoImage(file)} />
        </div>

        <BrandProfileActions onSave={handleSave} isSaving={isSaving} />
      </div>
    </ProfileSectionPage>
  );
};

export default BrandLogoPage;
